module.exports = __webpack_public_path__ + "img/licensedInstitution.d5f0511a.png";